/** The photo words on a check row (core proof.ts): a leaf, so the main web chunk carries only these. */
import type { PhotoAsk } from "./proof.ts";

/** The words on the check itself (the rest of the photo words are in proofgaps.ts, off the main web chunk). */
export const PHOTO_ASK_WORDS = { optional: "Add a photo (optional)", daily: "Photo asked for today", every: "Photo asked for each time" } as const;

/** The words for a check's photo row: "Add a photo (optional)", "Photo asked for today" or "Photo asked for each time". */
export function photoWords(a: Pick<PhotoAsk, "level" | "asked"> | undefined): string {
  if (!a || !a.asked || a.level === "optional") return PHOTO_ASK_WORDS.optional;
  return a.level === "daily" ? PHOTO_ASK_WORDS.daily : PHOTO_ASK_WORDS.every;
}

